import React from "react";
import {
  Card,
  Row,
  Col,
  Spin,
  Statistic,
  notification,
  Icon,
  Tooltip,
} from "antd";
import { Line } from "react-chartjs-2";
import services from "./service";

const QUEUE_DESCRIPTION = {
  "sms.smpp":
    "a queue that receives and sends tasks from frontend logic processing, such as deduction of funds, changing sender IDs/messages, and serves as the point of transmission to various vendors",
  "sms.smpp_dn":
    "a queue that receives the delivery status from every gateway and filters it to be sent to each SMPP customer",
  "sms.smpp.bridge":
    "a queue that replaces the old communication method that used HTTP. It's a queue that connects the SMPP server and the Movider core service. The queue contains messages that have not yet passed through any Movider logic",
};
class SMPPQueueStatus extends React.Component {
  state = {
    loading: false,
    queueData: {},
  };

  fetchData = async () => {
    try {
      this.setState({ loading: true });
      const response = await services._getMetric();
      const newData = response || [];
      const newQueueData = { ...this.state.queueData };

      newData.forEach((queue) => {
        const { queue_name, metric } = queue;

        if (!newQueueData[queue_name]) {
          newQueueData[queue_name] = {
            metric,
            messages: [],
            messagesReady: [],
            messagesUnacknowledged: [],
            timestamps: [],
            key: 0,
          };
        }

        // Append new data points
        const currentTime = new Date().toLocaleTimeString();
        newQueueData[queue_name].timestamps.push(currentTime);
        newQueueData[queue_name].messages.push(metric.messages);
        newQueueData[queue_name].messagesReady.push(metric.messages_ready);
        newQueueData[queue_name].messagesUnacknowledged.push(
          metric.messages_unacknowledged
        );

        const historyLimit = 30;
        if (newQueueData[queue_name].timestamps.length > historyLimit) {
          newQueueData[queue_name].timestamps.shift();
          newQueueData[queue_name].messages.shift();
          newQueueData[queue_name].messagesReady.shift();
          newQueueData[queue_name].messagesUnacknowledged.shift();
        }

        newQueueData[queue_name].key += 1;
      });

      this.setState({
        queueData: newQueueData,
        loading: false,
      });
    } catch (error) {
      notification.error({
        message: "Historical Error",
        description: error,
      });
      this.setState({ loading: false });
    }
  };

  async componentDidMount() {
    await this.fetchData();
    this.intervalId = setInterval(this.fetchData, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  renderQueueStatic = (queueName) => {
    const historicalData = this.state.queueData[queueName];
    if (!historicalData) {
      return null;
    }

    const queueMetric = historicalData.metric;
    const messageData = {
      labels: historicalData.timestamps,
      datasets: [
        {
          label: "Ready",
          data: historicalData.messagesReady,
          borderColor: "#4CAF50",
          backgroundColor: "rgba(76, 175, 80, 0.2)",
          tension: 0.1,
          pointRadius: 0,
        },
        {
          label: "Unacknowledged",
          data: historicalData.messagesUnacknowledged,
          borderColor: "#FFC107",
          backgroundColor: "rgba(255, 193, 7, 0.2)",
          tension: 0.1,
          pointRadius: 0,
        },
        {
          label: "Total",
          data: historicalData.messages,
          borderColor: "#2196F3",
          backgroundColor: "rgba(33, 150, 243, 0.2)",
          tension: 0.1,
          pointRadius: 0,
        },
      ],
    };

    return (
      <Row
        className="component monitor-card"
        gutter={[16, 16]}
        style={{ marginBottom: "20px" }}
        key={queueName}
      >
        <Col span={24}>
          <Card
            title={
              <span>
                Queue: {queueName}{" "}
                <Tooltip title={QUEUE_DESCRIPTION[queueName]}>
                  <Icon
                    type="exclamation-circle-o"
                    style={{ color: "#fefefe", borderColor: "#fefefe" }}
                  />
                </Tooltip>
              </span>
            }
            bordered={false}
          >
            <Row gutter={16}>
              <Col span={8}>
                <Statistic title="Messages" value={queueMetric.messages} />
              </Col>
              <Col span={8}>
                <Statistic title="Consumers" value={queueMetric.consumers} />
              </Col>
              <Col span={8}>
                <Statistic title="Memory (Bytes)" value={queueMetric.memory} />
              </Col>
            </Row>
            <Row gutter={16} style={{ marginTop: "20px" }}>
              <Col span={24}>
                <div className="chart-container">
                  <Line key={historicalData.key} data={messageData} />
                </div>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginTop: "20px" }}>
              <Col span={8}>
                <Statistic title="State" value={queueMetric.state} />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Durable"
                  value={queueMetric.durable ? "True" : "False"}
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Auto Delete"
                  value={queueMetric.auto_delete ? "True" : "False"}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  };

  render() {
    const queueNames = Object.keys(this.state.queueData);
    return (
      <Spin
        spinning={this.state.loading && queueNames.length === 0}
        tip="Loading..."
      >
        {queueNames.length > 0 ? (
          queueNames.map((name) => this.renderQueueStatic(name))
        ) : (
          <div style={{ textAlign: "center", padding: "50px" }}>
            No queue data available.
          </div>
        )}
      </Spin>
    );
  }
}

export default SMPPQueueStatus;



// WEBPACK FOOTER //
// ./src/containers/SmppMonitor/worker.js